/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_Rectification_DescInputs */

const en_privacy_section_7_rectification_desc = /** @type {(inputs: Privacy_Section_7_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`request correction of inaccurate or incomplete data`)
};

const lv_privacy_section_7_rectification_desc = /** @type {(inputs: Privacy_Section_7_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pieprasīt neprecīzu vai nepilnīgu datu labošanu`)
};

/**
* | output |
* | --- |
* | "request correction of inaccurate or incomplete data" |
*
* @param {Privacy_Section_7_Rectification_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_rectification_desc = /** @type {((inputs?: Privacy_Section_7_Rectification_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_Rectification_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_rectification_desc(inputs)
	return en_privacy_section_7_rectification_desc(inputs)
});